function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_6487",
  "data-name": "Group 6487",
  transform: "translate(-580.753 -236.743)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Union_17",
  "data-name": "Union 17",
  d: "M76.331,144.247v-6.272H23.023v6.272a6.272,6.272,0,0,1-12.543,0v-6.272a12.58,12.58,0,0,1,12.543-12.543H43.406v-6.271H55.949v6.271H76.331a12.58,12.58,0,0,1,12.543,12.543v6.272a6.272,6.272,0,0,1-12.543,0ZM49.677,134.84a6.29,6.29,0,0,1-6.272-6.272A6.29,6.29,0,0,0,49.677,134.84Zm6.271-6.272c0,.122,0,.242-.01.362.006-.12.01-.24.01-.362v0ZM12.4,112.109c-6.874,0-12.4-4.757-12.4-10.672,0-9.269,8.717-16.77,19.491-16.77H79.736c10.774,0,19.491,7.5,19.491,16.77,0,5.916-5.529,10.672-12.4,10.672Zm10.7-34.531a19.147,19.147,0,0,1-14.6-6.465A16.855,16.855,0,0,1,4.451,56.5l8.537-42.022C14.709,6.077,22.557,0,31.575,0H67.3c9.088,0,16.936,6.077,18.657,14.481L94.43,56.5a16.608,16.608,0,0,1-3.993,14.611,19.143,19.143,0,0,1-14.594,6.465Z",
  transform: "translate(580.753 236.743)",
  fill: "#000"
}));

function SvgChairOffice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99.227,
    height: 150.519,
    viewBox: "0 0 99.227 150.519",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChairOffice);
export default __webpack_public_path__ + "static/media/chair-office.60fdb100.svg";
export { ForwardRef as ReactComponent };